import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';

export const calculatorValidator = z.object({
    type: z.literal(ELEMENT.CALCULATOR),
    calculatorId: z.string().min(1, {
        message: 'presEditPage.editSidebar.elements.calculator.notFound',
    }),
});
